module.exports = __webpack_public_path__ + "assets/img/d18df1a8b5d1dffe6cea45a3e58fe800.svg";